import { FirebaseRemoteConfigContext } from "~applications";
import { createStaticContextProvider, lazyValue } from "~utils";

export const RemoteConfigProvider = createStaticContextProvider(
  FirebaseRemoteConfigContext,
  lazyValue(() =>
    import("./remote-config").then((module) => module.remoteConfig),
  ),
);
